import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-88fe0a22"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "zhuanpei"
};
const _hoisted_2 = {
  style: {
    "text-align": "left"
  }
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("分类：");

const _hoisted_4 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("彩票：");

const _hoisted_6 = {
  class: "tabs"
};
const _hoisted_7 = {
  style: {
    "margin-left": "10px",
    "color": "red"
  }
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "green"
  },
  type: "primary",
  size: "small"
}, "快速设置：", -1));

const _hoisted_9 = {
  class: "sub"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存设置");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");

  const _component_el_radio_button = _resolveComponent("el-radio-button");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_input_number = _resolveComponent("el-input-number");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.pid,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pid = $event),
    size: "small",
    onChange: _cache[1] || (_cache[1] = $event => $options.get_loss_data('', $event))
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.play_arr, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.name,
        label: item.pid
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.gid,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.gid = $event),
    size: "small",
    onChange: _cache[3] || (_cache[3] = $event => $options.get_loss_data($event, ''))
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_list, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.id,
        label: item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.gname), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_table, {
    data: $data.loss_data,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    append: _withCtx(() => [_createVNode(_component_el_row, {
      style: {
        "padding": "3px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 6,
        offset: 17
      }, {
        default: _withCtx(() => [_hoisted_8, _createVNode(_component_el_input_number, {
          size: "small",
          modelValue: $data.fast.inputnum,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.fast.inputnum = $event),
          step: 0.0001,
          min: 0,
          onChange: $options.fastset
        }, null, 8, ["modelValue", "step", "onChange"])]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: "下注类型",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "high_rate",
      label: "赔率上限",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "low_rate",
      label: "赔率下限",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "play_rate",
      label: "赚取",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input_number, {
        size: "small",
        modelValue: scope.row.inputnum,
        "onUpdate:modelValue": $event => scope.row.inputnum = $event,
        min: scope.row.inputnum_min,
        max: scope.row.inputnum_max,
        step: 0.0001,
        onChange: $event => scope.row.play_rate = (scope.row.high_rate - scope.row.inputnum).toFixed(4)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "step", "onChange"]), _createElementVNode("span", _hoisted_7, "最高：" + _toDisplayString(scope.row.inputnum_max), 1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
    size: "small",
    type: "info",
    onClick: _cache[5] || (_cache[5] = $event => $options.get_loss_data($data.gid, $data.pid))
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  }), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.sub_set
  }, {
    default: _withCtx(() => [_hoisted_11]),
    _: 1
  }, 8, ["onClick"])])]);
}